import { render } from "./Line.vue?vue&type=template&id=0dc604c0&scoped=true"
const script = {}

import "./Line.vue?vue&type=style&index=0&id=0dc604c0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc604c0"]])

export default __exports__